import React from 'react';

const TransactionsStatsCards = ({ transactions }) => {
  const averageValue = transactions.reduce((acc, curr) => acc + curr.value, 0) / transactions.length;
  const weightedAveragePrice = transactions.reduce((acc, curr) => acc + (curr.price * curr.amount), 0) / transactions.reduce((acc, curr) => acc + curr.amount, 0);

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-4">
      <h3 className="text-lg font-semibold text-center mb-4">Average Transaction</h3>
      <p><strong>Value:</strong> ${averageValue.toLocaleString('en-US', {
        maximumFractionDigits: 0
      })}</p>
      <p><strong>Price:</strong> ${weightedAveragePrice.toFixed(5)}</p>
    </div>
  );
};

export default TransactionsStatsCards;
